/**
 * Manage a Classes cache so we can reuse styles without recreating them.
 * 
 * This has two great advantages:
 * 
 * - Performance: because we dont need to fully reprocess a style if it has 
 *    already been processed and defined.
 * 
 * - Code size: because a style tag is no included in every component when it 
 *    has already been defined.
 *  
 * Documents and examples:
 *  https://www.w3.org/wiki/Dynamic_style_-_manipulating_CSS_with_JavaScript
 *  https://developer.mozilla.org/en-US/docs/Web/API/StyleSheetList
 *  https://developer.mozilla.org/en-US/docs/Web/API/StyleSheet
 *  http://www.javascriptkit.com/domref/stylesheet.shtml
 * 
 * @author: Mario Zito <mario.zito@treme,io>
 * @created: 20/04/2021
 */

let _CACHE = {};

let _STYLO_SHEET = null; // the Stylo Sheet index


function createStyloSheet() {
  /**
   * Creates a special Sheet for Stylo classes
   * @returns: index of the created Sheet 
   */
  var sheet = document.createElement('style')
  sheet.setAttribute("id", "stylo")
  sheet.setAttribute("title", "Stylo")
  document.body.appendChild(sheet);

  // now find the sheet an return it 
  for(var i=0; i < document.styleSheets.length; i++) {
    var sheet = document.styleSheets[i];
    // console.log("createStyloSheet sheet ",i, sheet.id, sheet.title);
    if(sheet.title == "Stylo") {
      return sheet;
    }
  }
}


export function addStyloClass(name, content) {
  /**
   * Add a class rule to the special Stylo StyleSheet.
   * @name: the class name
   * @content: the rule content, as in "color:red;border:1px solid blue;..."
   */
  if (!_STYLO_SHEET)
    _STYLO_SHEET = createStyloSheet();

  //let styloSheet = document.styleSheets[_STYLO_SHEET]; //document.styleSheets.length-1];
  _STYLO_SHEET.insertRule(`.${name} { ${content} }`)

  // add it to the cache so we can use it latter
  _CACHE[name] = _STYLO_SHEET.cssRules.length - 1 ;

  // console.log("SHEET", _STYLO_SHEET);
}


export function isStyloClass(name) {
  /**
   * Returns if a given class name alrady exists in the Cache
   * @returns: True if exists, False otherwise.
   */
  return (_CACHE[name] !== undefined);
}
